module.exports = __webpack_public_path__ + "img/In-N-Out_logo.8ad65381.svg";